import Stack from '@mui/material/Stack';
import { Facet, WithSearch } from "@elastic/react-search-ui";
import FilterPill from "./pill";
import globalStyles from "../search.module.css"
import styles from './pills.module.css';

type Props = {
  filters: filters[],
  mapView: boolean,
  clearFilters: any,
  setFilter: any,
  forSale: boolean,
  includeDefaultOptions: boolean,
  category_code: string,
  defaultFilters: filters[]
}

type filters = {
  field: string,
  values: string[]
}

const FilterPillsBar = ({ filters, mapView, clearFilters, setFilter, forSale, includeDefaultOptions, category_code, defaultFilters }: Props) => {

  const newFilters = filters.filter((f => !['size_ft_max', 'rent_pa', 'size_m_max', 'includePOA', 'ui:category_code', 'ui:availability'].includes(f.field)));
  const reset = () => {
    clearFilters()
    defaultFilters.forEach((f) => {
      setFilter(f.field, f.values, 'all')
    })
  }
  const mapStyles = mapView ? styles.mapView : '';
  return (
    <div className={newFilters.length > 0 ? `${styles.scroll} ${styles.FilterPillsContainer} ${styles.padding} ${mapStyles}` : `${styles.FilterPillsContainer} ${styles.hide}`} >
      <Stack direction="row" spacing={1}>
        {filters.map((f) => (
          <Facet
            key={f.field}
            field={f.field}
            label={f.field}
            view={(props) => {
              let includeUI = (f.field === 'category_code' && category_code !== 'ALL') ? true :
                (!!(f.field === 'availability' && category_code === 'ALL'));
              return <FilterPill {...props}
                setFilter={setFilter}
                field={f.field}
                includeUI={includeUI}
                lableLookUp={f.field === 'category_code' ? 'FILTER_CATEGORIES_' : ''}
                correctValues={f.values}
              />
            }}
          />

        ))}
      </Stack>

      <button className={globalStyles.buttonTopBar} onClick={(e) => { reset() }}>
        Reset
      </button>

    </div >
  )
}

type FilterPillsProps = {
  mapView?: string | null;
  categories: any;
  forSale: boolean;
  category_code: any;
  defaultFilters: any;
}

const FilterPills = ({ ...props }: FilterPillsProps) => {
  return <WithSearch mapContextToProps={(context) => ({ ...context, ...props })}>
    {(props) => {
      return <FilterPillsBar {...props} />
    }}
  </WithSearch>
}

export default FilterPills;
